/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import r from '../../../util/Renderer'
import { DatePicker, Dropdown, TextInput } from '../../atoms'
import { Edit } from '../../molecules'
import ReservationAction from '../../../action/reservation'
import MoneyInput from '../../unit/MoneyInput'
import { MealConditionInstance } from '../../../domain/model/plan/MealCondition'

function ReservationEditView(props) {
  const reservationStatusOptions = creteReservationOptions(props.reservation)
  const invoiceAutomationOptions = createInvoiceAutomationOptions(props.invoice_automation)

  return (
    <Edit
      title={props.reservation.id ? `予約ID：${props.reservation.id}` : '新規予約'}
      buttonLabel={props.reservation.id ? '更新' : '作成'}
      buttonDisabled={props.toolbar.saveButtonDisabled}
      onCancel={ReservationAction.cancelCreationView}
      onSubmit={() => {
        props.reservation.id ? ReservationAction.onRequestUpdate(props.reservation) : ReservationAction.onRequestCreate(props.reservation)
      }}
    >
      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <p className="input-required">宿泊施設</p>
            <Dropdown name="room_id" value={props.reservation.room_id} onChange={ReservationAction.onEdit} options={props.room_options} />
          </div>
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <div className="EditArea__column">
            <p className="input-required">種類</p>
            <Dropdown name="status" value={props.reservation.status} onChange={ReservationAction.onEdit} options={reservationStatusOptions} />
          </div>
        </div>
        {r.renderIf(!props.reservation.id && !props.session.isOwner && props.reservation.status !== 'not_a_reservation')(
          <div className="EditArea__row--half">
            <div className="EditArea__column">
              <p className="input-required">自動請求の実行</p>
              <Dropdown name="execute_invoice_automation" value={props.reservation.execute_invoice_automation} onChange={ReservationAction.onEdit} options={invoiceAutomationOptions} />
            </div>
          </div>
        )}
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <div className="EditArea__column">
            <p className="input-required">チェックイン</p>
            <DatePicker name="check_in" selected={props.reservation.check_in} onChange={ReservationAction.onEdit} />
          </div>
        </div>
        <div className="EditArea__row--half">
          <div className="EditArea__column">
            <p className="input-required">チェックアウト</p>
            <DatePicker name="check_out" selected={props.reservation.check_out} onChange={ReservationAction.onEdit} />
          </div>
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <TextInput value={props.reservation.first_name} type="text" name="first_name" onChange={ReservationAction.onEdit} placeholder="姓(First name)" label={'宿泊者'} option="required" />
        </div>
        <div className="EditArea__row--half">
          <TextInput value={props.reservation.last_name} type="text" name="last_name" onChange={ReservationAction.onEdit} placeholder="名(Given name)" />
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <TextInput value={props.reservation.num_adult} type="text" name="num_adult" placeholder="人数" label={'大人'} option="required" onChange={ReservationAction.onEdit} />
        </div>
        <div className="EditArea__row--half">
          <div className="EditArea__row--half--quater">
            <TextInput value={props.reservation.num_child} type="text" name="num_child" placeholder="人数" label={'子供'} option="required" onChange={ReservationAction.onEdit} />
          </div>
          <div className="EditArea__row--half--quater">
            <TextInput value={props.reservation.num_infant} type="text" name="num_infant" placeholder="人数" label={'幼児'} option="required" onChange={ReservationAction.onEdit} />
          </div>
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <MoneyInput value={props.reservation.accommodation_fee} name="accommodation_fee" label={'料金'} onChange={ReservationAction.onEdit} />
        </div>
        <div className="EditArea__row--half">
          <MoneyInput value={props.reservation.commission} name="commission" label={'OTA手数料'} onChange={ReservationAction.onEdit} />
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <Dropdown placeholder="予約元" name="site_referer" value={props.reservation.site_referer} onChange={ReservationAction.onEdit} options={props.site_referrer_options} />
        </div>
        <div className="EditArea__row--half">
          <TextInput value={props.reservation.reservation_code || '(変更不可)'} type="text" name="reservation_code" label={'予約番号'} disabled={true} />
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <p>食事条件</p>
          <Dropdown name="meal_condition_pms" value={props.reservation.getMealConditionValue()} onChange={ReservationAction.onEdit} options={MealConditionInstance.options} />
        </div>
        <div className="EditArea__row--half">
          <p>食事提供時刻</p>
          <TextInput name="meal_delivery" value={props.reservation.meal_delivery} onChange={ReservationAction.onEdit} />
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <TextInput value={props.reservation.email} type="text" name="email" label={'メールアドレス'} onChange={ReservationAction.onEdit} />
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <TextInput value={props.reservation.phone_number} type="text" name="phone_number" label={'電話番号'} onChange={ReservationAction.onEdit} />
        </div>
        <div className="EditArea__row--half">
          <TextInput value={props.reservation.mobile_number} type="text" name="mobile_number" label={'携帯電話'} onChange={ReservationAction.onEdit} />
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <TextInput value={props.reservation.country} type="text" name="country" label={'国籍'} onChange={ReservationAction.onEdit} />
        </div>
      </div>
      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <TextInput value={props.reservation.guest_arrival_time} type="text" name="guest_arrival_time" label={'到着時刻'} onChange={ReservationAction.onEdit} />
        </div>
      </div>

      <div className="EditArea__column">
        <p>社内メモ</p>
        <textarea className="EditArea__row--full" name="notes" value={props.reservation.notes || ''} rows="6" onChange={ReservationAction.onEdit} />
      </div>

      <div className="EditArea__column">
        <p>社外共有事項</p>
        <textarea className="EditArea__row--full" name="shared_notes" value={props.reservation.shared_notes || ''} rows="6" onChange={ReservationAction.onEdit} />
      </div>

      <br />
    </Edit>
  )
}

function creteReservationOptions(reservation) {
  if (!reservation.id) {
    // 新規
    return [
      { value: reservation.getStatusValueOfBooked(), label: reservation.getStatusLabelOfBooked() },
      { value: reservation.getStatusValueOfNotReservation(), label: reservation.getStatusLabelOfNotReservation() }
    ]
  }
  // 更新
  return [
    { value: reservation.getStatusValueOfBooked(), label: reservation.getStatusLabelOfBooked() },
    { value: reservation.getStatusValueOfCancelled(), label: reservation.getStatusLabelOfCancelled() },
    { value: reservation.getStatusValueOfNotReservation(), label: reservation.getStatusLabelOfNotReservation() }
  ]
}

function createInvoiceAutomationOptions(invoice_automation) {
  if (!invoice_automation) {
    return [invoice_automation.getDisabledOption()]
  }

  return invoice_automation.getOptions()
}

export default ReservationEditView
